/**
 * Defined in:
 *   {@link file://./../../../../dxos/echo/model/text.proto}
 */
export var TextKind;
(function (TextKind) {
    TextKind[TextKind["PLAIN"] = 0] = "PLAIN";
    TextKind[TextKind["RICH"] = 1] = "RICH";
})(TextKind || (TextKind = {}));
//# sourceMappingURL=text.js.map